import { checkboxAnatomy } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react"

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys)

const signupStyleSingleLine = definePartsStyle({
  label: defineStyle({
    fontSize: "15px",
    color: "white",
    lineHeight: "18px"
  })
})
const signupStyleDoubleLine = definePartsStyle({
  container: defineStyle({
    alignItems: "flex-start"
  }),
  label: defineStyle({
    fontSize: "15px",
    color: "white",
    lineHeight: "18px"
  }),
  control: defineStyle({
    marginTop: "4px"
  })
})

export const loginCheckboxTheme = defineMultiStyleConfig({ variants: { signupStyleSingleLine, signupStyleDoubleLine } })
